
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, AlertOctagon, Trophy, ThumbsDown } from "lucide-react";
import { ProgressBar } from './ProgressBar';

interface SimpleCardStatsCardProps {
  title: string;
  totalCards: number;
  average: string;
  mostCards: { team: string; average: number };
  leastCards: { team: string; average: number };
  overUnderStats: { threshold: number; over: string; under: string }[];
}

const SimpleCardStatsCard: React.FC<SimpleCardStatsCardProps> = ({
  title,
  totalCards,
  average,
  mostCards,
  leastCards,
  overUnderStats
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <AlertCircle className="h-4 w-4 text-yellow-500" />
              <span>Total: {totalCards}</span>
            </div>
            <div className="flex items-center gap-2">
              <AlertOctagon className="h-4 w-4 text-red-500" />
              <span>Average: {average}</span>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <Trophy className="h-4 w-4 text-yellow-500" />
              <span>Most: {mostCards.team} ({mostCards.average.toFixed(2)})</span>
            </div>
            <div className="flex items-center gap-2">
              <ThumbsDown className="h-4 w-4 text-blue-500" />
              <span>Least: {leastCards.team} ({leastCards.average.toFixed(2)})</span>
            </div>
          </div>
          
          <div className="space-y-2">
            {overUnderStats.map(({ threshold, over }) => (
              <div key={threshold} className="flex justify-between items-center gap-4">
                <span className="text-sm w-24">Over {threshold.toFixed(1)}</span>
                <div className="flex-1">
                  <ProgressBar percentage={over} color="bg-yellow-500" />
                </div>
                <span className="text-sm font-medium w-16 text-right">{over}%</span>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SimpleCardStatsCard;
